'use client'
import { Link as AscendLink, Box } from '@achieve/ascend'
import { MenuList, MenuItem } from 'components/Menu'
import { Typography } from 'components/Contentful'
import { useState, useMemo } from 'react'
import { withUuid } from 'utils/shared'

function ArticleTOC({ content, withTitle = true, variantItem = 'labelSm', activeSection }) {
  const [actualSection, setActualSection] = useState(null)
  const contentList = useMemo(() => withUuid(content || []), [content])

  const subNavMenuItemCreator = () => {
    return contentList.map((item, index) => {
      const sectionContentId = item.id
      const sectionContentName = item.text

      return (
        <MenuItem
          key={item.uuid}
          className="group/item whitespace-normal min-h-auto bg-white flex flex-row items-stretch p-0"
          tabIndex={-1}
          onClick={() => setActualSection(sectionContentId)}
          data-active={
            activeSection ? activeSection === sectionContentId : actualSection === sectionContentId
          }
        >
          <div className="min-w-[4px] min-h-full bg-[#c0cbd8] after:content-[''] after:block after:min-w-[4px] after:min-h-[50%] after:mt-2 group-hover/item:bg-[#3300ff] group-hover/item:rounded-3xl group-data-[active=true]/item:bg-[#3300ff] group-data-[active=true]/item:rounded-3xl" />
          <AscendLink
            section-index={index}
            variant={variantItem}
            href={`#${sectionContentId}`}
            aria-current={actualSection === sectionContentId}
            className="text-[#1d252f] no-underline p-2 group-hover/item:bg-white group-hover/item:z-1 group-hover/item:font-bold! group-hover/item:text-[#3300ff] group-data-[active=true]/item:bg-white group-data-[active=true]/item:z-1 group-data-[active=true]/item:font-bold! group-data-[active=true]/item:text-[#3300ff] font-normal"
          >
            {sectionContentName}
          </AscendLink>
        </MenuItem>
      )
    })
  }

  return (
    <Box>
      {withTitle && (
        <Typography
          variant={'headingMd'}
          component={'span'}
          fontWeight="medium"
          className="block mt-4 mb-6"
          content="Table of Contents"
        />
      )}
      <MenuList className="mb-4 p-0" tabIndex={0} data-testid="table-of-contents-list">
        {subNavMenuItemCreator()}
      </MenuList>
    </Box>
  )
}

export { ArticleTOC }
